/**
 * Helpers for turning a drag-and-drop DataTransfer into a flat File[] — including
 * walking dropped folder trees (webkitGetAsEntry). Shared by the import dialog and
 * the Studies page drop zone.
 */
/** True when a drag carries files (vs text / elements). */
export function dataTransferHasFiles(dt) {
    return !!dt && Array.from(dt.types).includes('Files');
}
async function collectFilesFromEntry(entry, out) {
    if (entry.isFile) {
        const file = await new Promise((resolve, reject) => {
            ;
            entry.file(resolve, reject);
        });
        out.push(file);
        return;
    }
    if (entry.isDirectory) {
        const reader = entry.createReader();
        const readBatch = () => new Promise((resolve, reject) => reader.readEntries(resolve, reject));
        // readEntries returns chunks; call until empty.
        let batch = await readBatch();
        while (batch.length > 0) {
            for (const child of batch) {
                await collectFilesFromEntry(child, out);
            }
            batch = await readBatch();
        }
    }
}
/**
 * Flattens a DataTransfer (files and/or dropped folders) into a File[]. Uses the
 * webkitGetAsEntry directory API when available, falling back to the flat file list.
 */
export async function filesFromDataTransfer(dt) {
    // Grab entries synchronously — the items list becomes invalid after the handler returns.
    const entries = [];
    if (dt.items && dt.items.length > 0) {
        for (let i = 0; i < dt.items.length; i++) {
            const item = dt.items[i];
            if (item.kind !== 'file')
                continue;
            const entry = item.webkitGetAsEntry?.();
            if (entry)
                entries.push(entry);
        }
    }
    if (entries.length > 0) {
        const out = [];
        for (const entry of entries) {
            await collectFilesFromEntry(entry, out);
        }
        return out;
    }
    // Fallback for environments without the entries API.
    return Array.from(dt.files ?? []);
}
